"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function Loom24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M22.5 10.833H16.359L21.678 7.7625L20.5095 5.7375L15.192 8.8095L18.261 3.4905L16.2375 2.322L13.17 7.6395V1.5H10.83V7.641L7.761 2.322L5.739 3.4905L8.808 8.808L3.4905 5.739L2.322 7.761L7.641 10.8315H1.5V13.167H7.6395L2.322 16.2375L3.4905 18.2625L8.808 15.192L5.7375 20.5095L7.7625 21.678L10.8315 16.359V22.5H13.167V16.359L16.2375 21.678L18.261 20.5095L15.1905 15.1905L20.508 18.261L21.6765 16.2375L16.359 13.1685H22.4985L22.5 10.833ZM12 15.177C11.1542 15.177 10.3431 14.841 9.74504 14.243C9.14698 13.6449 8.811 12.8338 8.811 11.988C8.811 11.1422 9.14698 10.3311 9.74504 9.73304C10.3431 9.13498 11.1542 8.799 12 8.799C12.8458 8.799 13.6569 9.13498 14.255 9.73304C14.853 10.3311 15.189 11.1422 15.189 11.988C15.189 12.8338 14.853 13.6449 14.255 14.243C13.6569 14.841 12.8458 15.177 12 15.177Z", fill: "#383F49" }));
}
function Loom24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(Loom24Svg, Object.assign({}, svgProps)));
}
exports.default = Loom24;
//# sourceMappingURL=Loom24.js.map